export const getTextByUserLangAndType = (faq, type, otherType, lang) => {
	const translation = faq.translation.find((t) => t.lang === lang);

	if (translation) {
		return translation[type];
	}

	return faq[otherType];
};
